export enum ApiTag {
	Organization = 'Organization',
	OrganizationSpecialist = 'OrganizationSpecialist',
	Specialist = 'Specialist',
	Patient = 'Patient',
	User = 'User',
	// OrganizationStatistics = 'OrganizationStatistics',
}
